// Default (English) minimap strings. The app passes translated labels via the `labels` prop
// (EN + ES live in apps/app/src/i18n); these defaults keep @aod/ui usable on its own.

import type { MinimapLabels } from './types.js';

export const DEFAULT_MINIMAP_LABELS: MinimapLabels = {
  title: 'Minimap',
  ariaLabel:
    'Minimap. Arrow keys move the focus, Enter centres the camera there, C jumps to the next own city, plus and minus zoom, zero fits the whole board.',
  summary:
    'Minimap: {cities} cities visible, zoom {zoom}x, camera at {camera}, focus {q},{r}: {what}',
  zoomIn: 'Zoom in',
  cameraBox: 'Camera view box',
  zoomOut: 'Zoom out',
  fit: 'Fit board',
  legend: 'Legend',
  legendTitle: 'Minimap legend',
  tileUnexplored: 'Unexplored',
  tileCoords: '({q}, {r})',
  owner: 'Owner: {owner}',
  unclaimed: 'Unclaimed',
  player: 'Player {player}',
  you: 'You',
  city: 'City',
  cityNamed: 'City {name}',
  cityTier: 'Tier {tier}',
  capital: 'Capital',
  village: 'Neutral village',
  unitsOwn: 'Your units: {count}',
  unitsOther: 'Units: {count}',
  explored: 'Explored',
  fog: 'Fog',
  unit: 'Unit',
  border: 'Territory border',
  marker: 'Champion',
  layers: 'Layers',
  layerTerritory: 'Territory',
  layerFog: 'Fog of war',
  layerUnits: 'Cities & units',
  layerRivers: 'Rivers',
  layerRelief: 'Relief',
  size: 'Size',
  sizeS: 'Small',
  sizeM: 'Medium',
  sizeL: 'Large',
  collapse: 'Collapse minimap',
  expand: 'Expand minimap',
  biomes: {},
};

/** Fill `{name}` placeholders. */
export function fmt(template: string, vars: Readonly<Record<string, string | number>>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m));
}

export function mergeLabels(partial: Partial<MinimapLabels> | undefined): MinimapLabels {
  return partial ? { ...DEFAULT_MINIMAP_LABELS, ...partial } : DEFAULT_MINIMAP_LABELS;
}
